export default __webpack_public_path__ + "media/images/logo-text-81f02d9d06e01a1be8a7686906d2f2a6.png";